import { gsap } from "gsap";

(() => {
  const loading = document.querySelector(".js-loding");
  window.addEventListener(
    "load",
    () => {
      gsap.to(loading, {
        opacity: 0,
        onComplete: () => {
          loading.parentNode.removeChild(loading);
        },
      });
    },
    false
  );
})();
